import { MaxLength, Matches, IsOptional, IsNotEmpty} from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { BloodGroupEnum } from '@gtpl/shared-models/gtpl';
export class DonorsDTO {
  @ApiProperty()
  @IsOptional()
  donorsId?: number;


  @ApiProperty()
  @MaxLength(60, { message: "Donors Name allows maximum 15 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Donors name should be only alpha numeric" })
  donorName: string;

  @ApiProperty()
  @IsNotEmpty()
  phoneNo: string;

  @ApiProperty()
  country: string;
  
  @ApiProperty()
  state: string;

  @ApiProperty()
  district: string;
  
  @ApiProperty()
  constituency: string;

  @ApiProperty()
  bloodGroup: string;

  @ApiProperty()
  createdAt : Date;

  
}

